<template>
  <div class="filter">
    <div class="row">
      <div class="row-left">
        <div class="small-3 columns end">
          <div class="search-box">
            <label class="field-label">Search</label>
            <div class="search">
              <div class="search-input-box">
                <input type="text" v-model="searchInput" ref="search" :disabled="loading"
                  v-on:keypress.enter="search" v-on:blur="blurSearch" />
                  <transition name="slide-left">
                    <i class="far fa-times-circle fa-lg" @click="clearSearch"
                      v-if="searchInput.length > 0"></i>
                  </transition>
              </div>
              <button :class="{'button xsmall success':true, 'disabled':loading}"
                @click="search">
                <i class="fas fa-search fa-lg"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="small-2 columns end">
          <div class="status">
            <label class="field-label">Status</label>
            <select v-model="status" :disabled="loading">
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="deactivated">Inactive</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row-right">
        <div class="small-2 columns small-offset-4">
          <div class="search-box right">
            <div :class="{'button cta add-btn':true, 'disabled':loading}"
              @click="showForm">
              <i class="fas fa-plus"></i>
              <span>Add Admin</span>
            </div>
          </div>
        </div>

        <div class="small-1 columns">
          <div class="search-box right export">
            <div :class="{'button cta success add-btn block':true, 'disabled':exportLoading}"
              @click="exportAdmin">
              <span v-if="exportLoading">Loading...</span>
              <span v-else>EXPORT</span>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import ApiAdmin from '@/modules/api/admin'
import CsvExport from 'csvexport'

const exporter = CsvExport.create({
  filename: 'export.csv',
  columns: [ 'First Name', 'Last Name', 'Username', 'Email', 'Mobile', 'Active' ]
})

export default {
  name: 'admin-filter',
  data () {
    return {
      searchInput: '',
      blurDelay: '',
      exportLoading: false
    }
  },
  computed: {
    loading () { return this.$store.state.admin.loading },
    status: {
      get: function () { return this.$store.state.admin.status },
      set: function (value) {
        this.$store.commit('admin/setStatus', value)
        this.refreshTable()
      }
    }
  },
  methods: {
    showForm () { this.$store.commit('admin/setShowForm', true) },
    refreshTable () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('admin/setLoading', true)
      self.$store.commit('admin/setCurrentPage', 1)

      ApiAdmin.getAdmins(self, {}, res => {
        self.$store.commit('admin/setLoading', false)
      })
    },
    search () {
      this.$store.commit('admin/setSearch', this.searchInput)
      this.refreshTable()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.admin.search === self.searchInput.trim()) { return }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }
      if (this.loading) { return }

      this.searchInput = ''
      this.$store.commit('admin/setSearch', '')
      this.refreshTable()
    },
    updateStatus () {
      // this.$store.commit('provider/setUserIsLoading', true)
      // this.refreshTable()
    },
    exportAdmin () {
      let self = this
      if (self.exportLoading) { return }

      self.exportLoading = true
      ApiAdmin.export(self, res => {
        self.exportLoading = false
        if (!res.error) {
          exporter.downloadCsv(res)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter{
  border-bottom:1px solid #bbb;
  background: #fcfcfc;
  margin-bottom: 10px;
  border-radius: 2px;

  .row{ max-width: 100%; }
}

.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.search-box{
  display: inline-block;
  padding: 10px 0 10px 15px;
  position: relative;
  width: 100%;

  .error-msg{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 15px);
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    margin-left: 15px;
    background: #ff6115;
    color: #fff;
    transform-origin: bottom center;
  }
  &.right{
    text-align: right;
    padding-right: 15px;
  }
  &.export{ padding-left: 0px; }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.status{
  display: inline-block;
  padding: 10px 0 10px 15px;
  width: 100%;

  &.last{ padding-right: 10px; }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.add-btn{
  margin-top: 10px;
}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .column, .columns {
    float: none;
    width: 50%;
  }
  .row-left,
  .row-right {
    display: flex;
  }
  .small-offset-4 {
    margin-left: unset;
  }

  .add-btn {
    margin-top: 0;
    width: 100%;
  }
  .status {
    padding: 10px;
  }
  .search-box.right {
    padding-top: 0;
  }
  .filter {
    .row {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Filter.vue